import routeNames from "@/router/names";
import LayoutAuth from "@/views/layouts/auth.vue";
import AuthLogin from "@/views/auth/login.vue";
import TermsOfUse from "@/views/TermsOfUse.vue";
import type { RouteRecordRaw } from "vue-router";
import ProjectsDashboardListProjects from "@/views/projects/dashboard/list-projects.vue";

export default [
  {
    path: '/',
    name: routeNames.projectsDashboard,
    component: ProjectsDashboardListProjects,
    strict: false
  },
  {
    path: '/login',
    component: LayoutAuth,
    meta: {
      requiresAuth: false,
      page: {
        title: 'Login'
      }
    },
    children: [
      {
        path: '',
        name: routeNames.login,
        component: AuthLogin
      }
    ]
  },
  {
    path: '/terms-and-conditions',
    name: routeNames.termsAndConditions,
    component: TermsOfUse,
    meta: {
      requiresAuth: true
    }
  }
] as RouteRecordRaw[]